import { render, staticRenderFns } from "./MaterialCardCustomDashboard.vue?vue&type=template&id=077139d0&scoped=true&"
import script from "./MaterialCardCustomDashboard.vue?vue&type=script&lang=js&"
export * from "./MaterialCardCustomDashboard.vue?vue&type=script&lang=js&"
import style0 from "./MaterialCardCustomDashboard.vue?vue&type=style&index=0&id=077139d0&prod&scoped=true&lang=css&"
import style1 from "./MaterialCardCustomDashboard.vue?vue&type=style&index=1&id=077139d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077139d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VRow})
